import http from "../http-common";

class DocumentDataService {
  getAll() {
    return http.get("/documents");
  }

  vrfyDocument(ac, cn) {
    console.log("- Service: 2-");
    return http.get(`/documents/findDoc/${ac}/${cn}`);
  }

  get(id) {
    return http.get(`/documents/${id}`);
  }

  create(data) {
    console.log(data);
    return http.post("/documents", data);
  }

  update(id, data) {
    return http.put(`/documents/${id}`, data);
  }

  delete(id) {
    return http.delete(`/documents/${id}`);
  }

  deleteAll() {
    return http.delete(`/documents`);
  }

  findByAccessCode(ac, cn) {
    return http.get(`/documents?access_code=${ac}&case_number=${cn}`);
  }
  
}

export default new DocumentDataService();